export const CLIENT_ROUTES = {
	HOME: '/',
	AUTH: '/auth',
	REGISTER: '/register',
	VERIFY_EMAIL: '/verify-email/:id',
	FORGOT_PASSWORD: '/forgot-password',
	RESET_PASSWORD: '/reset-password/:token',
	ARCHITECTS_DESIGNERS: '/architects-designers',
	ABOUT_US: '/about-us',
	CONTACT: '/contact',
	QNA: '/qna',
	CART: '/cart',
	CHECKOUT: '/checkout',
	PRODUCT_DETAILS: '/product/:id',
	CATEGORIES: '/categories',
	PRIVACY_POLICY: '/privacy-policy',
	TERMS_OF_SERVICE: '/terms-of-service',
	PRODUCTS: {
		BASE: '/products',
		CATEGORY_PRODUCTS: '/category/:categoryId',
		RECOMMENDED: '/recommended',
		SALE: '/sale',
	},
	ADMIN: {
		BASE: '/admin',
		ROUTES: {
			CATEGORIES: '/categories',
			PRODUCTS: {
				BASE: '/products',
				CREATE: '/create',
				EDIT: '/edit/:id',
				VIEW: '/view/:id',
			},
			SETTINGS: '/settings',
			ORDERS: '/orders',
			COUPONS: '/coupons',
			SHIPMENTS: '/shipments',
			USERS: '/users',
			PROFILE: '/profile',
			ANALYTICS: '/analytics',
			CUSTOM_PAGES: '/custom-pages',
			NEWS_LETTER: '/newsletter',
			POSTERS: '/posters',
		},
	},
};

export const SERVER_ROUTES = {
	BASE: '/api',
	USER: {
		version: 'v1',
		BASE: '/user',
		ROUTES: {
			BASE: '/',
			REGISTER: '/register',
			RESET_PASSWORD: '/reset-password',
			RESET_PASSWORD_EMAIL: '/reset-password/email',
			VERIFICATION_EMAIL: '/verification-email',
			VERIFY_EMAIL: '/verify-email/:id',
			CHANGE_PASSWORD: '/password',
			UPDATE_USER_DATA: '/',
			LIST: '/list',
			DELETE: '/:id',
		},
	},
	AUTH: {
		version: 'v1',
		BASE: '/auth',
		ROUTES: {
			LOGIN: '/login',
			LOGOUT: '/logout',
			REFRESH_TOKEN: '/refresh-token',
			GOOGLE: '/google',
			DEVICES: '/devices',
			LOGOUT_DEVICE: '/device/logout/:id',
		},
	},
	INVENTORY: {
		version: 'v1',
		BASE: '/inventory',
		ROUTES: {
			BASE: '/',
			UPDATE_PRODUCT_STOCK: '/product/:productId',
		},
	},
	CATEGORY: {
		version: 'v1',
		BASE: '/category',
		ROUTES: {
			BASE: '/',
			CREATE: '/',
			UPDATE: '/:id',
			DELETE: '/:id',
			LIST: '/list',
			GET_BY_ID: '/get/:id',
		},
	},

	SHIPMENT: {
		version: 'v1',
		BASE: '/shipment',
		ROUTES: {
			BASE: '/',
			CREATE: '/',
			UPDATE: '/:id',
			DELETE: '/:id',
			LIST: '/list',
			GET_BY_ID: '/get/:id',
		},
	},

	PRODUCT: {
		version: 'v1',
		BASE: '/product',
		ROUTES: {
			BASE: '',
			CREATE: '',
			GET_BY_ID: '/get/:id',
			UPDATE: '/:id',
			DELETE: '/:id',
			LIST: '/list',
			LIST_ROUTES: {
				ALL: '/all',
				LATEST: '/latest',
				IDS: '/ids',
			},
		},
	},

	SETTINGS: {
		version: 'v1',
		BASE: '/settings',
		ROUTES: {
			BASE: '/',
			UPDATE: '/',
			LIST: '/list',
		},
	},
	ORDER: {
		version: 'v1',
		BASE: '/order',
		ROUTES: {
			BASE: '/',
			CREATE: '/',
			INTENT: '/intent',
			UPDATE: '/:id',
			DELETE: '/:id',
			LIST: '/list',
			GET_BY_ID: '/get/:id',
			RESEND_ORDER_EMAIL: '/resend-email/:id',
			STATISTICS: '/statistics',
		},
	},
	COUPON: {
		version: 'v1',
		BASE: '/coupon',
		ROUTES: {
			BASE: '/',
			CREATE: '/',
			UPDATE: '/:id',
			DELETE: '/:id',
			LIST: '/list',
			GET_BY_CODE: '/get/code/:code',
			GET_BY_ID: '/get/id/:id',
		},
	},
	CONTACT: {
		version: 'v1',
		BASE: '/contact',
		ROUTES: {
			SUBMIT_FORM: '/submit',
		},
	},
	PAYMENT: {
		version: 'v1',
		BASE: '/payment',
		ROUTES: {
			URL: '/url',
			NOTIFY: '/notify',
		},
	},
	CONFIG: {
		version: 'v1',
		BASE: '/config',
		ROUTES: {
			BASE: '/',
		},
	},
};
